module.exports = __webpack_public_path__ + "0758e4d6d7b59821475005b8c597f418.svg";